import script from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=4b345a1b&lang=scss"

const __exports__ = script;

export default __exports__